import * as React from 'react';

const Northeast = ({ ...props }) => (
    <svg
        width="11"
        height="11"
        viewBox="0 0 11 11"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
    >
        <path
            d="M9.69336 9.55242L9.69334 2.27913L1.56161 10.4109L0.623929 9.47317L8.75565 1.34144L1.49774 1.31977L2.76728 -5.35329e-05L10.9999 -6.09508e-05L10.9999 8.49995L9.69336 9.55242Z"
            fill="currentColor"
        />
    </svg>
);

export default Northeast;
